@if (formElement?.fieldType === FormFieldType.Select) {
    @switch (formElement?.elementType) {
        @case (FORM_ELEMENT_TYPE.Field) {
            @switch (formElement?.elementStyle) {
                @case (FORM_ELEMENT_STYLE.Radios) {
                    <ng-container [formGroup]="$any(controlContainer?.control)">
                        <wdx-form-field
                            [locked]="formElement?.isLocked"
                            [label]="
                                formElement?.label | translateTokenisedString
                            "
                            [guidanceText]="
                                formElement?.guidanceText
                                    | translateTokenisedString
                            "
                            [isSensitive]="
                                formElement?.isSensitive ?? undefined
                            "
                            [isRequired]="formElement?.isRequired ?? undefined"
                            [validationErrorMessage]="
                                formControl?.touched
                                    ? (formControl?.errors
                                      | validationErrorMessage)
                                    : ''
                            "
                            [warningMessage]="warningText"
                        >
                            @for (
                                option of fieldDefOptions$ | ngrxPush;
                                track option.value;
                                let i = $index
                            ) {
                                <wdx-radio
                                    [label]="option.label"
                                    [labelForId]="inputId"
                                    [value]="option.value"
                                >
                                    <input
                                        type="radio"
                                        class="form-check-input"
                                        [formControlName]="
                                            $any(formElement.name)
                                        "
                                        [value]="option.value"
                                        [attr.data-cy]="
                                            'option-' +
                                            formElement.name +
                                            '-' +
                                            option.value
                                        "
                                        [wdxUtilsDisabled]="
                                            isDisabled ||
                                            formElement?.pendingChange
                                                ?.status ===
                                                PENDING_CHANGE_STATUS_TYPE.Submitted
                                        "
                                    />
                                </wdx-radio>
                            }
                        </wdx-form-field>
                    </ng-container>
                }

                @case (FORM_ELEMENT_STYLE.RadioTiles) {
                    <ng-container [formGroup]="$any(controlContainer?.control)">
                        <wdx-form-field
                            class="h-100 d-block"
                            [locked]="formElement?.isLocked"
                            [label]="
                                formElement?.label | translateTokenisedString
                            "
                            [guidanceText]="
                                formElement?.guidanceText
                                    | translateTokenisedString
                            "
                            [isSensitive]="
                                formElement?.isSensitive ?? undefined
                            "
                            [isRequired]="formElement?.isRequired ?? undefined"
                            [validationErrorMessage]="
                                formControl?.touched
                                    ? (formControl?.errors
                                      | validationErrorMessage)
                                    : ''
                            "
                        >
                            <wdx-radio-tile-group>
                                @for (
                                    option of fieldDefOptions$ | ngrxPush;
                                    track option.value;
                                    let i = $index
                                ) {
                                    <wdx-radio-tile
                                        [label]="option.label"
                                        [labelForId]="inputId"
                                        [value]="option.value"
                                    >
                                        <input
                                            type="radio"
                                            [formControlName]="
                                                $any(formElement.name)
                                            "
                                            [value]="option.value"
                                            [attr.data-cy]="
                                                'option-' + option.value
                                            "
                                            [wdxUtilsDisabled]="
                                                isDisabled ||
                                                formElement?.pendingChange
                                                    ?.status ===
                                                    PENDING_CHANGE_STATUS_TYPE.Submitted
                                            "
                                        />

                                        @if (option.iconStack) {
                                            <wdx-icon-stack icon>
                                                @for (
                                                    icon of option.iconStack;
                                                    track $index
                                                ) {
                                                    <wdx-icon
                                                        [icon]="
                                                            icon.icon +
                                                            ' fa-2x fa-stack-1x ' +
                                                            icon.style
                                                        "
                                                        [rotate]="icon?.rotate"
                                                        [offsetTop]="
                                                            icon?.offsetTop
                                                        "
                                                        [offsetLeft]="
                                                            icon?.offsetLeft
                                                        "
                                                        [scale]="icon?.scale"
                                                    ></wdx-icon>
                                                }
                                            </wdx-icon-stack>
                                        }

                                        @if (option.icon) {
                                            <wdx-icon
                                                icon
                                                [icon]="option.icon + ' fa-2x'"
                                            ></wdx-icon>
                                        }
                                    </wdx-radio-tile>
                                }
                            </wdx-radio-tile-group>
                        </wdx-form-field>
                    </ng-container>
                }

                @case (FORM_ELEMENT_STYLE.ButtonGroup) {
                    <ng-container [formGroup]="$any(controlContainer?.control)">
                        <wdx-form-field
                            [locked]="formElement?.isLocked"
                            [label]="
                                formElement?.label | translateTokenisedString
                            "
                            [guidanceText]="
                                formElement?.guidanceText
                                    | translateTokenisedString
                            "
                            [isSensitive]="
                                formElement?.isSensitive ?? undefined
                            "
                            [isRequired]="formElement?.isRequired ?? undefined"
                        >
                            <wdx-radio-group-form-control
                                [buttonsConfig]="
                                    $any(fieldDefOptions$ | ngrxPush)
                                "
                                [formControlName]="$any(formElement.name)"
                            ></wdx-radio-group-form-control>
                        </wdx-form-field>
                    </ng-container>
                }
            }
        }
    }
}
